/**
 * 取得與目標日期的差距天數與狀態
 * @param {Date} today 當前日期
 * @param {string} targetISODate 目標日期 (YYYY-MM-DD 或 ISO Date字串)
 */
export function getDayDiff(today, targetISODate) {
  // 🛡️ 關鍵修復：防呆機制
  // 確保目標日期存在且為字串，避免 undefined.split() 導致整個畫面崩潰
  if (!targetISODate || typeof targetISODate !== 'string') {
    console.warn('⚠️ 發現無效的日期格式:', targetISODate);
    const fallbackDate = today instanceof Date && !Number.isNaN(today.getTime()) ? today : new Date();
    targetISODate = `${fallbackDate.getFullYear()}-${String(fallbackDate.getMonth() + 1).padStart(2, '0')}-${String(fallbackDate.getDate()).padStart(2, '0')}`; // 發生異常時預設回退到今天，保護畫面不崩潰
  }

  const safeToday = today instanceof Date && !Number.isNaN(today.getTime()) ? today : new Date();
  const datePart = targetISODate.split('T')[0];
  const [year, month, day] = datePart.split('-').map(Number);
  const parsedDate = new Date(Date.UTC(year, month - 1, day));
  const isValidDate = /^\d{4}-\d{2}-\d{2}$/.test(datePart) &&
    parsedDate.getUTCFullYear() === year &&
    parsedDate.getUTCMonth() === month - 1 &&
    parsedDate.getUTCDate() === day;
  const targetDate = isValidDate
    ? parsedDate
    : new Date(Date.UTC(safeToday.getFullYear(), safeToday.getMonth(), safeToday.getDate()));
  
  const todayDate = new Date(Date.UTC(safeToday.getFullYear(), safeToday.getMonth(), safeToday.getDate()));
  
  const diffTime = targetDate.getTime() - todayDate.getTime();
  const rawDiff = Math.round(diffTime / (1000 * 60 * 60 * 24));
  
  let status = 'today';
  if (rawDiff > 0) status = 'remaining';
  else if (rawDiff < 0) status = 'elapsed';

  // 回傳星期的 Index (0-6)，由 UI 透過 i18n 自行決定顯示語言
  const weekDayIndex = targetDate.getUTCDay();

  return {
    diffDays: Math.abs(rawDiff),
    rawDiff,
    status,
    weekDayIndex,
    isValid: isValidDate
  };
}